<template>
  <div>
    <ButtonSquare
      size="small"
      class="navigation-buttons__button"
      :imgSource="iconRotateClockwise"
      @clicked="() => changeBearing('clockwise')"
    />
    <ButtonSquare
      size="small"
      class="navigation-buttons__button"
      :imgSource="iconRotateCounterClockwise"
      @clicked="() => changeBearing('counterClockwise')"
    />
  </div>
</template>

<script setup lang="ts">
import { useStore } from 'vuex'
import ButtonSquare from '@/components/general/buttons/ButtonSquare/ButtonSquare.vue'
import iconRotateClockwise from '@/assets/icons-general/rotate_clockwise.svg'
import iconRotateCounterClockwise from '@/assets/icons-general/rotate_counterclockwise.svg'

const store = useStore()

function changeBearing(direction: 'clockwise' | 'counterClockwise') {
  // @ts-expect-error - map not typed
  const currentBearing = store.map.getBearing()
  const rotation = direction === 'counterClockwise' ? 5 : -5
  const animationDuration = 300
  // @ts-expect-error - map not typed
  store.map.flyTo({
    bearing: currentBearing + rotation,
    curve: 0.5,
    screenSpeed: 0.5,
    easing: (t: number) => t,
    duration: animationDuration
  })
}
</script>

<style lang="scss" scoped>
.navigation-buttons__button {
  margin: 0px 0px 10px 0px;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
